/* template */
<template><div class="card card_item_ui"><div class="goods_item"><div class="package_pic"><mpx-image :src="(goods.goods_pic || '')" alt="" class="package_image"></mpx-image></div><div class="package_info"><div class="package_title">{{goods.goods_name}}</div><div class="package_price"><text-money :price-type="(goods.currency)" :price-new="(goods.price)" :price-old="(goods.price !== goods.original_price ? goods.original_price : '')"></text-money><span class="member_tips" v-if="(goods.dis_rule && goods.dis_rule.show_tag)">{{goods.dis_rule.show_tag}}</span><span class="member_tips" v-else-if="(goods.is_spike === 4)">买赠套餐</span><span class="member_tips" v-if="(rightData.isShow)">{{rightData.show_tag}}</span></div><div class="content-circuit" v-if="(goods.circuit)"><text-circuit :goods="(goods)"></text-circuit></div><div class="content-package" v-else><text-package :goods="(goods)"></text-package></div><div class="package_bottom clearfix"><div class="pull_left" v-if="((goods.goods_type == 4 || goods.goods_type == 99) && goods.logo_info)"><div v-for="(item, index) in (goods.logo_info.logos)" :key="item.index" class="icon_shop"><mpx-image :src="(item || '')"></mpx-image></div><div class="saved_tips">{{goods.logo_info.hint}}</div></div><div :class='("btn_buy "+(isSoldout && goods.goods_type !== 3 ? "btn_buy_grey": ""))' v-if="(goods.is_spike === 0)">{{isSoldout && goods.goods_type !== 3 ? $t('common.soldOut') : $t('common.goBuy')}}</div><div :class='("btn_buy "+(isSoldout ? "btn_buy_grey": ""))' v-else>{{isSoldout ? $t('common.soldOut'): goods.buy_time_text}}</div></div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4cd5f06a"}'>
@import '../../../lib/stylus/border'
.text_light {
  opacity: 0.6
}
.card
  min-height: 288rpx
  box-sizing: border-box
  padding: 30rpx 32rpx 26rpx
  border-bottom: 1px solid #ebeced
  overflow: hidden
  &:active {
    background-color: #eff6fd
  }
.goods_item {
  display: flex

  .package_pic {
    width: 200rpx
    height: 117rpx
    overflow: hidden
    margin-right: 20rpx
    position relative

    .package_image {
      width: 100%
      height: 100%
      border-radius: 5rpx
    }
    .cate_mark{
      position absolute
      left 0
      top 0
      height 29rpx
      line-height 29rpx
      background-image: linear-gradient(180deg, #FFEDED 0%, #F7E7E1 100%);
      border-radius: 0 0 20rpx 0;
      font-family: PingFangSC-Regular;
      font-size: 18rpx;
      color: #313131;
      letter-spacing: 0;
      padding 0 11rpx
    }
  }

  .package_info {
    flex: 1

    .package_title {
      color: #333
      font-size: 32rpx
      font-weight: 700
      margin-bottom: 20rpx
      line-height: 1.1
      margin-top: 2rpx
      width: 100%
    }

    .package_price {
      font-family: PingFangSC-Semibold
      align-items: center
      display: flex

      .price_new {
        font-size: 36rpx
        font-weight: 700
        color: #FC9153
        margin-right: 14rpx
        line-height: 30rpx
        vertical-align: middle

        .money {
          line-height: 30rpx
          margin-left: -6rpx
          margin-right: -6rpx
        }
      }

      .price_old {
        color: #999
        font-size: 24rpx
        vertical-align: middle
        line-height: 30rpx
        opacity: 0.6
        text-decoration: line-through
        padding: 0 10rpx
      }

      .member_tips {
        color: #fff
        font-size: 20rpx
        padding: 5rpx 10rpx
        margin-left: 12rpx
        line-height: 24rpx
        background-image: linear-gradient(-114deg, #FB4948 0%, #FE6965 100%)
        border-radius: 2rpx
      }
    }
    .package_bottom {
      height: 60rpx
      line-height: 60rpx

      .saved_tips {
        color: #999
        font-size: 24rpx
        line-height: 32rpx
      }

      .btn_buy {
        float: right
        box-sizing: border-box
        text-align: center
        padding: 0 20rpx
        height: 60rpx
        line-height: 60rpx
        border: 1px solid #FC9153
        // border-1px(,,,#FC9153,2rpx)
        color: #FC9153
        font-size: 24rpx

        &.btn_buy_grey {
          border: 1px solid rgba(0, 0, 0, 0.1)
          color: #999999
        }

        &.precise_border {
          &:after {
            border-radius: 2px
          }
        }
      }
    }
  }
}

.pull_left {
  float: left
  font-size: initial
}

.pull_right {
  float: right
}

.clearfix:after {
  content: ''
  display: block
  clear: both
}

.icon_shop {
  border-radius: 50%
  display: inline-block
  width: 40rpx
  height: 40rpx
  line-height: 32rpx
  position: relative
  margin-left: -10rpx
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1)
  border: 1rpx, solid, rgba(0, 0, 0, 0.1)

  &:after {
    border-radius: 50%
  }

  img {
    border-radius: 50%
    position: relative
    display: inline-block
    width: 100%
    height: 100%
    box-sizing: border-box
  }

  &:before {
    content: ''
    position: absolute
    display: block
    z-index: -1
    border-radius: 50%
    background: #fff
    top: -2rpx
    left: -2rpx
    width: 46rpx
    height: 46rpx
  }

  &:first-child {
    margin-left: 0
  }
}
.content-circuit
  margin: 15rpx 0 16rpx 0
.content-package
  margin: 15rpx 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  properties: {
    goods: Object,
  },
  computed: {
    isSoldout() {
      if (this.goods.is_spike === 3) { // 拼团商品
        return this.goods.single_balance_left === 0 && this.goods.group_balance_left === 0
      }
      return this.goods.balance_left === 0
    },
     // 为了兼容快升专
    rightData(){
      if(this.goods.rights && this.goods.rights.theme){
        return {
          isShow:true,
          show_tag:this.goods.rights.theme==='spike_time_limit'?'限时秒杀':'限量秒杀',
        }
      }else{
        return {
          isShow:false,
          show_tag:'',
        }
      }
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "index4cd5f06a",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'text-money':getComponent(require("../../app-ui/text-money.mpx?component=true&componentId=text-money35e493b0")),'text-tag':getComponent(require("../../app-ui/text-tag.mpx?component=true&componentId=text-tagfef5a77c")),'text-circuit':getComponent(require("../../app-ui/text-circuit.mpx?component=true&componentId=text-circuit607a1491")),'text-package':getComponent(require("./text-package.mpx?component=true&componentId=text-package6f9d6f7c")),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
